export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export default {
  setDrawer: set('drawer'),
  setResponsive: set('responsive'),
  setLoggedIn: set('is_logged'),
  setAlert: set('show_alert'),
  setAlertColor: set('alert_color'),
  setOverlayLoading: set('overlay_loading'),
  setOverlayLoadingText: set('overlay_loading_text'),
  setAlertText: set('alert_text'),
  setSuppliers: set('suppliers'),
  setTrucks: set('trucks'),
  setDrivers: set('drivers'),
  setSettings: set('settings'),
  setCategories: set('categories'),
  setProducts: set('products'),
  setCustomertypes: set('customertypes'),
  setCustomers: set('customers'),
  setUsers: set('users'),
  setAvailables: set('availables'),
  setAllowedMenus: set('allowed_menus')
}
